import URLS from 'config/urls';
import BaseAPI from './BaseApi';
import type { LoginResponseModel } from 'models/auth/responses/LoginResponseModel';
import type { ErrorModel } from 'models/shared/ErrorModel';
import type { LoginPayloadModel } from 'models/auth/payloads/LoginPayloadModel';
import type { Request2faPayloadModel } from 'models/auth/payloads/Request2faPayloadModel';
import type { CompanyModel } from 'models/company/entities/CompanyModel';
import type { PaginatedResponseModel } from 'models/shared/PaginatedResponseModel';

class AuthService {
  //Lass
  async request2FA(data: Request2faPayloadModel): Promise<undefined | ErrorModel> {
    try {
      const response = await BaseAPI.post(`${URLS.MFA}`, data);
      return response.data;
    } catch (e) {
      return { error: "Erro ao solicitar 2FA" };
    }
  }

  async login(data: LoginPayloadModel): Promise<LoginResponseModel | ErrorModel> {
    try {
      const response = await BaseAPI.post(URLS.LOGIN, data);
      return response.data;
    } catch (e) {
      return { error: "Dados inválidos" };
    }
  }

  async getCompanyList(): Promise<PaginatedResponseModel<CompanyModel> | ErrorModel> {
    const params = { pageSize: 999 }
    try {
      const response = await BaseAPI.get(`${URLS.COMPANY_UUID}/related`, { params });
      return response.data;
    } catch (e) {
      return { error: "Erro ao consultar cadastro" };
    }
  }

  /**Faz requisição de redefinição de senha do email informado */
  async redefinePass(email: string, isStoom: boolean = false): Promise<any> {
    try {
      const response = await BaseAPI.post(isStoom
        ? URLS.FORGET_PASSWORD
        : URLS.AMERINODE_FORGET_PASSWORD, {
        email
      });
      return response;
    } catch (e) {
      return { error: "A recuperação de senha falhou" };
    }
  }

  async validateToken(token: string, isStoom: boolean = false): Promise<any> {
    try {
      const response = await BaseAPI.post(`${isStoom
        ? URLS.FORGET_PASSWORD
        : URLS.AMERINODE_FORGET_PASSWORD}validate_token/`, {
        token
      });
      return response;
    } catch (e) {
      return { error: "A recuperação de senha falhou" };
    }
  }

  async changePassword(token: string, password: string, isStoom: boolean = false): Promise<any> {
    try {
      const response = await BaseAPI.post(`${isStoom
        ? URLS.FORGET_PASSWORD
        : URLS.AMERINODE_FORGET_PASSWORD}confirm/`, {
        token,
        password,
      });
      return response;
    } catch (e) {
      return { error: "A recuperação de senha falhou" };
    }
  }


  async logout(): Promise<void> {
    // Lógica para logout
  }

  // async getCurrentUser(): Promise<User | null> {
  //     // Lógica para obter o usuário atual
  // }
}

const service = new AuthService()
export default service;